exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-filter[data-v-8cd1a9d0]{margin-top:20px}", "", {"version":3,"sources":["/app/src/components/clients/Clients.vue"],"names":[],"mappings":"AACA,6BACE,eAAiB,CAClB","file":"Clients.vue","sourcesContent":["\n.btn-filter[data-v-8cd1a9d0] {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8cd1a9d0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/clients/Clients.vue
// module id = 471
// module chunks = 0